// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vf5Vp","largestCol":"styles_largestCol__2IE_O","smallestCol":"styles_smallestCol__2UoMr"};